/**
 * @file: 手动设置货架的posX、posY
 * @author: xiaolong.huang@dmall.com
 */

import { findParentIdByCubeId, findByCubeId, findChildCubeByIndex } from './baseQuery';
import { findFreezer, findShelfs } from './advanceQuery';
import { getNumberValue } from './getCubeValue';
import { setCubeValueById } from './setCubeValue';
import { getCubeIndex, isFreezerTree } from './cubeInfo';

export default function updateShelfsPosition(): void {
    let shelfIds: Array<CubeId> = [];

    if (isFreezerTree()) {
        shelfIds = findFreezer();
    }
    else {
        shelfIds = findShelfs();
    }

    shelfIds.forEach((shelfId: CubeId, index: number): void => {
        setCubeValueById(shelfId, {
            posX: 0,
            posY: 0
        });
    });
}
